"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = { class: "settings-card-container" };
const _hoisted_3 = { class: "settings-title-wrapper" };
const _hoisted_4 = { class: "settings-item browser-settings-item" };
const _hoisted_5 = { class: "flex-center" };
const _hoisted_6 = { class: "oplus-form-radio" };
const _hoisted_7 = { class: "flex-center" };
const _hoisted_8 = { class: "oplus-form-radio" };
const _hoisted_9 = { class: "flex-center" };
const _hoisted_10 = { class: "oplus-form-radio" };
const _hoisted_11 = { class: "flex-center" };
const _hoisted_12 = { class: "oplus-form-radio" };
const _hoisted_13 = { class: "settings-card-container" };
const _hoisted_14 = { class: "settings-title-wrapper" };
const _hoisted_15 = { class: "settings-item" };
const _hoisted_16 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_17 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_18 = { class: "settings-submit-button-wrapper" };
const CSVIcon_vue_1 = __importDefault(require("../icons/CSVIcon.vue"));
const ShiftManagementIcon_vue_1 = __importDefault(require("../icons/ShiftManagementIcon.vue"));
const vue_3 = require("vue");
const settings_1 = require("../../js/settings");
const IndexedDBStorage_1 = require("../../storage/IndexedDBStorage");
const storageSummary_1 = require("../../storage/storageSummary");
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const common_1 = require("../../common/common");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsBrowserContent',
    setup(__props, { expose: __expose }) {
        const isLoading = (0, vue_3.ref)(false);
        const encodings = (0, vue_3.ref)("0");
        const savedEncoding = (0, vue_3.ref)("0");
        async function submitBrowserSettings() {
            if (isLoading.value) {
                return false;
            }
            try {
                isLoading.value = true;
                (0, settings_1.setCSVEncoding)(parseInt(encodings.value, 10));
                // since changing browser settings is likely instant (just updating local storage) we intentionally delay it to simulate async submit
                await new Promise(resolve => setTimeout(resolve, 300));
                savedEncoding.value = encodings.value;
                (0, common_1.showSaveSuccessSnackbar)();
                return true;
            }
            catch (err) {
                (0, settings_1.importAlertModal)().alert(err);
                return false;
            }
            finally {
                isLoading.value = false;
            }
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        async function handleClearSummaryPageCache() {
            const databases = await indexedDB.databases();
            for (const d of databases) {
                if (d.name === storageSummary_1.summaryDb) {
                    try {
                        const db = new IndexedDBStorage_1.IndexedDBStorage(storageSummary_1.summaryDb);
                        await db.clearAllStores();
                        db.close();
                        break;
                    }
                    catch (e) {
                        console.log(e);
                        alert("キャッシュを削除できませんでした。");
                        return;
                    }
                }
            }
            (0, settings_1.importAlertModal)().alertSuccess("シフト管理ページのキャッシュを削除しました！");
        }
        function hasUnsavedChanges() {
            return encodings.value !== savedEncoding.value;
        }
        __expose({
            hasUnsavedChanges,
            saveSettings: submitBrowserSettings,
        });
        (0, vue_3.onMounted)(() => {
            const currentEncoding = (0, settings_1.getCSVEncoding)();
            encodings.value = currentEncoding;
            savedEncoding.value = currentEncoding;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createCommentVNode)(" Browser settings "),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(CSVIcon_vue_1.default, { class: "page-title-text" }),
                        _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "CSV文字コード", -1 /* CACHED */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("label", _hoisted_6, [
                                _cache[5] || (_cache[5] = (0, vue_2.createTextVNode)(" UTF-8 BOM － Windows Excel ", -1 /* CACHED */)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((encodings).value = $event)),
                                    value: "0",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("label", _hoisted_8, [
                                _cache[7] || (_cache[7] = (0, vue_2.createTextVNode)(" UTF-8 BOMなし － MacOS Excel ", -1 /* CACHED */)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((encodings).value = $event)),
                                    value: "1",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                _cache[9] || (_cache[9] = (0, vue_2.createTextVNode)(" Windows 31J － Windows Excel \"Ansi\" ", -1 /* CACHED */)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((encodings).value = $event)),
                                    value: "2",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("label", _hoisted_12, [
                                _cache[11] || (_cache[11] = (0, vue_2.createTextVNode)(" UTF-16 LE － Windows Unicode ", -1 /* CACHED */)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((encodings).value = $event)),
                                    value: "3",
                                    type: "radio",
                                    name: "csv-browser-settings"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelRadio, encodings.value]
                                ]),
                                _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* CACHED */))
                            ])
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                    (0, vue_2.createElementVNode)("div", _hoisted_14, [
                        (0, vue_2.createVNode)(ShiftManagementIcon_vue_1.default, { class: "page-title-text" }),
                        _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, " シフト管理 ", -1 /* CACHED */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "キャッシュを削除", -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper last-tooltip" }, [
                                    (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "ブラウザに保存されているシフト管理ページの古いデータ（シフト・ユーザー情報）を削除します。")
                                ], -1 /* CACHED */))
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("label", { class: "settings-input oplus-form-switch" }, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn oplus-confirm-btn clear-btn",
                                onClick: handleClearSummaryPageCache
                            }, "削除")
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_18, [
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn oplus-save-btn", loadingClass.value]),
                        onClick: submitBrowserSettings
                    }, "保存", 2 /* CLASS */)
                ])
            ]));
        };
    }
});
